var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintNightmareFixDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66668 22.8527V28.186H21.1108L21.4103 26.7275V26.6472L17.0466 27.7369L18.4234 26.186H10.6667V20.4937H18.8306L16.8978 18.4937H8.66668V20.8527H5.71795V15.2629C5.71795 14.8851 5.84573 14.5685 6.10128 14.3129C6.35684 14.0574 6.67351 13.9296 7.05128 13.9296H24.7135L24.7996 13.6289L24.8996 13.9296H27.9717C27.7307 13.3399 27.3397 12.8591 26.7987 12.4873C26.2576 12.1155 25.641 11.9297 24.9487 11.9297H23.3333V5.92969H8.66668V11.9297H7.05128C6.11968 11.9297 5.33124 12.2491 4.68595 12.888C4.04066 13.5268 3.71802 14.3185 3.71802 15.2629V22.8527H8.66668ZM26.3333 17.8089L26.2246 17.9139L25.8205 16.6988H26.3333V17.8089ZM21.0591 18.4937H17.0884L21.2736 19.3529L21.0591 18.4937ZM21.3333 11.9297H10.6667V7.92966H21.3333V11.9297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1406 27.3969L28.7176 26.4889L29.8116 30.8699L26.4346 27.8719L25.1916 32.2129L23.7666 27.9279L20.5196 31.0659L21.4276 26.6429L17.0466 27.7369L20.0446 24.3599L15.7036 23.1169L19.9886 21.6919L16.8506 18.4449L21.2736 19.3529L20.1796 14.9719L23.5566 17.9699L24.7996 13.6289L26.2246 17.9139L29.4716 14.7759L28.5636 19.1989L32.9446 18.1049L29.9466 21.4819L34.2876 22.7249L30.0026 24.1499L33.1406 27.3969Z",
    stroke: "#368FEF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintNightmareFixDark);
export default __webpack_public_path__ + "static/media/print_nightmare_fix_dark.c7325ebacb17ade48b4285271e95affa.svg";
export { ForwardRef as ReactComponent };